import type { QueryClient } from "@tanstack/react-query";

export const AGENT_SPEC_PULL_QUERY_KEY = "agent-spec-pull";
export const AGENT_SPEC_V2_QUERY_KEY = "agent-spec-v2";
export const AGENT_RUNTIME_WORKFLOWS_QUERY_KEY = "agent-runtime-workflows";
export const AGENT_RUNTIME_MINIAPPS_QUERY_KEY = "agent-runtime-miniapps";

/** Prefixes watched by the Studio tree (Workflows + MiniApps) and the Agent Spec page. */
export function agentSpecResourceQueryKeys(
  organizationId: string,
  agentId?: string | null,
): string[][] {
  const scope = agentId
    ? [organizationId, agentId]
    : [organizationId];
  return [
    [AGENT_SPEC_PULL_QUERY_KEY, ...scope],
    [AGENT_SPEC_V2_QUERY_KEY, ...scope],
    [AGENT_RUNTIME_WORKFLOWS_QUERY_KEY, ...scope],
    [AGENT_RUNTIME_MINIAPPS_QUERY_KEY, ...scope],
  ];
}

export function invalidateAgentSpecResourceQueries(
  queryClient: QueryClient,
  organizationId: string | null | undefined,
  agentId?: string | null,
): Promise<void> {
  if (!organizationId) return Promise.resolve();
  return Promise.all(
    agentSpecResourceQueryKeys(organizationId, agentId).map((queryKey) =>
      queryClient.invalidateQueries({ queryKey }),
    ),
  ).then(() => undefined);
}
